/* DER Collection search: narrows the product grid the theme already rendered (#filter-results)
   by product title and vendor. Does not touch the theme's filters, sorting or pagination. The
   theme swaps #filter-results by AJAX when a filter changes, so the current query is re-applied
   whenever the grid's contents change. Submitting the form falls through to the store search. */
(function () {
  'use strict';
  var form = document.querySelector('[data-dc-search]');
  if (!form) return;
  var input = form.querySelector('[data-dc-input]');
  var clear = form.querySelector('[data-dc-clear]');
  var status = form.querySelector('[data-dc-status]');
  var total = parseInt(form.getAttribute('data-total'), 10) || 0;
  var query = '';

  function grid() { return document.getElementById('filter-results'); }
  function cards() {
    var g = grid();
    return g ? Array.prototype.slice.call(g.querySelectorAll('li.js-pagination-result')) : [];
  }
  function text(li) {
    var t = li.querySelector('.card__title'), v = li.querySelector('.card__vendor');
    return ((t ? t.textContent : '') + ' ' + (v ? v.textContent : '')).toLowerCase();
  }
  function escapeHtml(s) { return s.replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function apply() {
    var list = cards();
    var terms = query.toLowerCase().split(/\s+/).filter(Boolean);
    var shown = 0;
    list.forEach(function (li) {
      var isProduct = !!li.querySelector('.card__title');
      var ok = !terms.length || (isProduct && terms.every(function (t) { return text(li).indexOf(t) >= 0; }));
      li.classList.toggle('dc-hidden', !ok);
      if (ok && isProduct) shown++;
    });
    clear.hidden = !terms.length;
    if (!terms.length) { status.textContent = ''; return; }
    var q = escapeHtml(query);
    var more = total > list.length ? ' on this page' : '';
    var link = ' <a href="' + form.action + '?q=' + encodeURIComponent(query) + '&type=product&options%5Bprefix%5D=last">Search the whole store</a>';
    status.innerHTML = (shown ? shown + ' of ' + (total || list.length) + ' match' + more : 'No matches in this collection') + '.' + link;
  }

  var timer;
  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(function () { query = input.value.trim(); apply(); }, 120);
  });
  clear.addEventListener('click', function () { input.value = ''; query = ''; apply(); input.focus(); });
  form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });

  // Re-apply after the theme replaces the grid (filters, sort, infinite scroll).
  var g = grid();
  var target = g ? (g.closest('custom-pagination') || g.parentNode) : null;
  if (target && window.MutationObserver) {
    new MutationObserver(function () { if (query) apply(); }).observe(target, { childList: true, subtree: true });
  }
})();
/* Move the collection search into the products toolbar. 15 Oct 2026. */
(function(){
  function p(){
    var f=document.querySelector("form.dcs");
    if(!f||f.classList.contains("dcs--placed"))return;
    var t=document.querySelector("products-toolbar");
    var l=t&&t.querySelector(".products-toolbar__layout");
    if(t&&l){t.insertBefore(f,l);f.classList.add("dc-scope");}
    f.classList.add("dcs--placed");
  }
  if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",p);}else{p();}
})();
